import React from 'react';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Form, InputGroup, Button, Spinner, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SoftBadge from 'components/common/SoftBadge';

const LeadLinked = ({
    habilitarVinculacion,
    setHabilitarVinculacion,
    idLeadVincular,
    setIdLeadVincular,
    procesandoVincular,
    procesandoDesvincular,
    listaJsonLeadsVinculados,
    vincularLead,
    desvincularLead,
    ObtenerDatosLead,
    cargandoModal
}) => {
    // Generar array dinámico: mostrar todos los vinculados + 1 espacio para agregar
    const maxVinculaciones = Math.max(3, listaJsonLeadsVinculados.length + 1);
    const vinculacionIndices = Array.from({ length: maxVinculaciones }, (_, i) => i);

    return (
        <Col className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <Row>
                <Col className="col-12 fs--1 mb-3">
                    <h5>
                        <FontAwesomeIcon icon={icon({ name: 'link', style: "solid" })} size="lg" />
                        &nbsp;Vinculados
                    </h5>
                </Col>

                {vinculacionIndices.map((vinculacionIndex) => (
                    <Col key={vinculacionIndex} className="col-12 fs--1 mb-1" style={{ cursor: 'pointer' }}>
                        {habilitarVinculacion == (vinculacionIndex + 1) ? (
                            <Row className="mb-2 mt-2">
                                <Col className="col-11">
                                    <InputGroup className="fs--1 align-items-center">
                                        <Form.Control
                                            type="number"
                                            size="sm"
                                            disabled={cargandoModal}
                                            autoComplete="off"
                                            placeholder="Número de Lead"
                                            value={idLeadVincular}
                                            onChange={(e) => setIdLeadVincular(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") vincularLead();
                                            }}
                                        />
                                        {procesandoVincular ? (
                                            <Button variant="primary" size="sm" disabled>
                                                <Spinner
                                                    as="span"
                                                    animation="grow"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                                Procesando...
                                            </Button>
                                        ) : (
                                            <>
                                                <Button
                                                    disabled={procesandoVincular}
                                                    className="btn btn-primary"
                                                    size="sm"
                                                    type="submit"
                                                    onClick={() => vincularLead()}
                                                >
                                                    Vincular
                                                </Button>

                                                <FontAwesomeIcon
                                                    className="ms-2"
                                                    onClick={() => {
                                                        setHabilitarVinculacion(0);
                                                        setIdLeadVincular("");
                                                    }}
                                                    icon={icon({ name: 'xmark', style: "solid" })}
                                                    style={{ color: "#c32847" }}
                                                    size="xl"
                                                />
                                            </>
                                        )}
                                    </InputGroup>
                                </Col>
                            </Row>
                        ) : (
                            <>
                                {listaJsonLeadsVinculados.length >= (vinculacionIndex + 1) ? (
                                    <>
                                        <span>
                                            <Link
                                                to={"#"}
                                                onClick={() =>
                                                    ObtenerDatosLead(
                                                        listaJsonLeadsVinculados[vinculacionIndex].idLead
                                                    )
                                                }
                                            >
                                                <FontAwesomeIcon
                                                    className="me-2"
                                                    icon={icon({ name: 'headset', style: "solid" })}
                                                    style={{ color: "#000000" }}
                                                    size="lg"
                                                />

                                                <span className="text-dark fw-bold ">
                                                        {"Lead #" + listaJsonLeadsVinculados[vinculacionIndex].idLead + " | " + listaJsonLeadsVinculados[vinculacionIndex].vTelefonoLead}
                                                </span>

                                                <SoftBadge
                                                    className="ms-1"
                                                    bg={
                                                        listaJsonLeadsVinculados[vinculacionIndex].iDaysDiff >= 0 &&
                                                            listaJsonLeadsVinculados[vinculacionIndex].iDaysDiff < 3
                                                            ? "success"
                                                            : listaJsonLeadsVinculados[vinculacionIndex]
                                                                .iDaysDiff >= 3 &&
                                                                listaJsonLeadsVinculados[vinculacionIndex]
                                                                    .iDaysDiff < 5
                                                                ? "warning"
                                                                : "danger"
                                                    }
                                                >
                                                    {listaJsonLeadsVinculados[vinculacionIndex].iDaysDiff +
                                                        " días"}
                                                </SoftBadge>
                                            </Link>
                                            {procesandoDesvincular ? (
                                                <FontAwesomeIcon
                                                    className="ms-2"
                                                    icon={icon({ name: 'trash-can', style: "solid" })}
                                                    style={{ color: "#9da9bb" }}
                                                    disabled
                                                    size="lg"
                                                />
                                            ) : (
                                                <FontAwesomeIcon
                                                    className="ms-2"
                                                    onClick={() =>
                                                        desvincularLead(
                                                            listaJsonLeadsVinculados[vinculacionIndex].idLead
                                                        )
                                                    }
                                                    icon={icon({ name: 'trash-can', style: "solid" })}
                                                    style={{ color: "#c32847" }}
                                                    size="lg"
                                                />
                                            )}
                                        </span>
                                    </>
                                ) : (
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={<Tooltip id="tooltip">Vincular lead</Tooltip>}
                                    >
                                        <span onClick={() => setHabilitarVinculacion(vinculacionIndex + 1)}>
                                            <FontAwesomeIcon
                                                className="me-2"
                                                icon={icon({ name: 'headset', style: "solid" })}
                                                style={{ color: "#000000" }}
                                                size="lg"
                                            />
                                            <span className="text-muted ">Click para vincular lead</span>
                                        </span>
                                    </OverlayTrigger>
                                )}
                            </>
                        )}
                    </Col>
                ))}
            </Row>
        </Col>
    );
};

LeadLinked.propTypes = {
    habilitarVinculacion: PropTypes.number.isRequired,
    setHabilitarVinculacion: PropTypes.func.isRequired,
    idLeadVincular: PropTypes.string.isRequired,
    setIdLeadVincular: PropTypes.func.isRequired,
    procesandoVincular: PropTypes.bool,
    procesandoDesvincular: PropTypes.bool,
    listaJsonLeadsVinculados: PropTypes.array.isRequired,
    vincularLead: PropTypes.func.isRequired,
    desvincularLead: PropTypes.func.isRequired,
    ObtenerDatosLead: PropTypes.func.isRequired,
    cargandoModal: PropTypes.bool
};

export default LeadLinked;
